import { FC } from "react";
import { cn } from "utils/cn";
import type { ModalTitleIconProps } from "./ModalTitleIcon.types";

export const ModalTitleIcon: FC<ModalTitleIconProps> = ({ children, className }) => (
  <span
    className={cn(
      "flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-muted/50 text-primary [&>svg]:h-4 [&>svg]:w-4",
      className
    )}
    aria-hidden
  >
    {children}
  </span>
);
